import React, { FC } from 'react';
import { Form } from 'formik';
import { ModalContent, FlexGrid, FlexGridColumn } from '@clearcover/atlas';

import styles from './FormModalContent.module.css';

export const FormModalContent: FC = ({ children }) => {
  return (
    <ModalContent>
      <Form className={styles.formContainer}>
        <FlexGrid>
          <FlexGridColumn mobile={8} mobileOffset={2}>
            {children}
          </FlexGridColumn>
        </FlexGrid>
      </Form>
    </ModalContent>
  );
};

FormModalContent.displayName = 'FormModalContent';
